import { Toggle, ToggleGroup, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useFormState } from 'react-final-form';

import SelectAllToggle from '@swf/components/RegulatoryCheckboxes/SelectAllToggle';
import { ConsentMethod, ConsentType } from '@swf/core/enums';

import {
  TXTCLI_Casino,
  TXTCLI_Email,
  TXTCLI_Poker,
  TXTCLI_Sports,
  TXTMOB_Push_notifications,
  TXTWCL_How_would_you_like_to_be_conta_ELL,
  TXTWCL_What_would_you_like_to_hear_ab_ELL
} from './Fields.messages.json';
import styles from './Fields.scss';

const Fields: React.FC = () => {
  const { values } = useFormState();

  const consentMap = [
    {
      label: TXTWCL_How_would_you_like_to_be_conta_ELL,
      checkBoxes: {
        [ConsentMethod.Email]: TXTCLI_Email,
        [ConsentMethod.PushNotification]: TXTMOB_Push_notifications
      }
    },
    {
      label: TXTWCL_What_would_you_like_to_hear_ab_ELL,
      checkBoxes: {
        [ConsentType.Poker]: TXTCLI_Poker,
        [ConsentType.Casino]: TXTCLI_Casino,
        [ConsentType.Sport]: TXTCLI_Sports
      }
    }
  ];

  const checkboxes = [...Object.values(ConsentMethod), ...Object.values(ConsentType)] as string[];

  return (
    <>
      <SelectAllToggle checkboxes={checkboxes} values={values} />
      <fieldset>
        {consentMap.map(({ label, checkBoxes }) => (
          <ToggleGroup
            key={label.id}
            id={label.id}
            label={<Translation {...label} />}
            labelClassName={styles.marginTop}
            className={styles.content}
            name="signupConsentSelectAll"
          >
            {Object.entries(checkBoxes).map(([key, value]) => (
              <Toggle
                key={key}
                type="checkbox"
                id={key}
                name={key}
                label={value}
                className={styles.label}
              />
            ))}
          </ToggleGroup>
        ))}
      </fieldset>
    </>
  );
};

export default Fields;
